import React from 'react'
import { Outlet } from 'react-router-dom'
import { SideBar, Header, Divider } from 'components'

export const SideBarLayout = () => {
    return (
        <div className="flex relative justify-end flex-row min-h-screen">
            <SideBar className="md:w-60" />
            <div className="pb-6 grow relative w-[70%]">
                <Header />
                {/* <Divider className="bg-grey-light my-6" /> */}
                <div className="px-6">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}
